import axios from 'axios';

const baseUrl = import.meta.env.VITE_API_BASE_URL;
const root = `${baseUrl}/followups`;

// Lists & views: view = today | upcoming | overdue | completed | missed | history | all
export const fetchFollowups = async (params = {}) => {
  const res = await axios.get(root, { params });
  return res.data || { data: [], total: 0, page: 1, pageSize: 20, totalPages: 0 };
};

export const fetchCallDashboard = async () => (await axios.get(`${root}/dashboard`)).data || {};
export const fetchCalendar = async (start, end) => (await axios.get(`${root}/calendar`, { params: { start, end } })).data || [];
export const fetchNotifications = async () => (await axios.get(`${root}/notifications`)).data || { counts: {}, total: 0, items: [] };
export const fetchReports = async () => (await axios.get(`${root}/reports`)).data || {};
export const searchEntities = async (type, q) => (await axios.get(`${root}/search`, { params: { type, q } })).data || [];
export const fetchFollowup = async (id) => (await axios.get(`${root}/${id}`)).data;

export const createFollowup = (values) => axios.post(root, values);
export const updateFollowup = (id, values) => axios.put(`${root}/${id}`, values);
export const deleteFollowup = (id) => axios.delete(`${root}/${id}`);
export const completeFollowup = (id) => axios.post(`${root}/${id}/complete`);
export const cancelFollowup = (id) => axios.post(`${root}/${id}/cancel`);
export const missFollowup = (id) => axios.post(`${root}/${id}/miss`);
